"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const surface_1 = require("../../../../../../surface");
const withInlineValidation_1 = __importDefault(require("../../../../../wrappers/withInlineValidation"));
const links_1 = require("../../../../../utils/links");
class TextInput extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.handleChange = ({ target: { value } }) => {
            this.props.onChange(value === '' ? this.props.options.emptyValue : value);
        };
    }
    render() {
        const { id, label, placeholder, value, disabled, options, invalid, formContext } = this.props;
        const type = options.inputType || 'text';
        // check if the widget is locked because of forms links
        const isLocked = links_1.isLockedWidget(id, formContext.links);
        const FieldTextProps = {
            value: value === null ? '' : value.toString(),
            id,
            label,
            placeholder,
            disabled: disabled || isLocked,
            handleChange: this.handleChange,
            type,
            status: invalid ? 'invalid' : null
        };
        return jsx_runtime_1.jsx(surface_1.Textinput, Object.assign({}, FieldTextProps, { hideLabel: true }), void 0);
    }
}
exports.TextInput = TextInput;
TextInput.defaultProps = {
    id: '',
    label: '',
    value: '',
    placeholder: null,
    required: false,
    disabled: false,
    onChange: () => { }
};
exports.default = withInlineValidation_1.default(TextInput);
//# sourceMappingURL=index.js.map